// removed by extract-text-webpack-plugin
module.exports = {"flex":"LoadingSpinner__flex___3_WWY","flex-column":"LoadingSpinner__flex-column___7pU45","flex-column-center":"LoadingSpinner__flex-column-center___i6D0c","container":"LoadingSpinner__container___2RCDF","flex-row":"LoadingSpinner__flex-row___2emXl","flex-row-center":"LoadingSpinner__flex-row-center___1UmZG","progress":"LoadingSpinner__progress___3WiaW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner/LoadingSpinner.scss
// module id = 1159
// module chunks = 8